import validates from 'helpers/validates'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const phone = {
  name: 'phone',
  schemaType: STRING_SCHEMA_TYPE,
  method({ required = false, message = 'Número de telefone inválido' } = {}) {
    const schema = required ? this.required() : this

    return schema.test('is-valid-phone', message, (value) =>
      validates.phone.schema({ value, required }),
    )
  },
}

export default phone
